import React, { Fragment } from "react"
import { Helmet } from "react-helmet"




//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import ProjectGridOne from "../../../components/project/ProjectGridOne"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"
import { Link } from "react-router-dom"


const ProjectGrid = () => {

    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Portafolio de Proyectos Tecnológicos</title>
                    <meta name="description" content="Descubre los proyectos tecnológicos de CuySoft en Ecuador. Portafolio de desarrollo web, software a medida, ciberseguridad y soluciones digitales." />
                    <meta name="keywords" content="proyectos tecnológicos Ecuador, portafolio desarrollo web, casos de éxito software, CuySoft proyectos" />
                    <link rel="canonical" href="https://www.cuysoft.com/project-grid" />
                    <meta property="og:title" content="Portafolio de Proyectos – CuySoft Ecuador" />
                    <meta property="og:description" content="Proyectos tecnológicos exitosos: desarrollo web, software a medida y soluciones digitales." />
                    <meta property="og:url" content="https://www.cuysoft.com/project-grid" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Nuestros Proyectos" />
                {/* PageTitle */}

                {/*cuysoft-project-one start*/}
                <section className="cuysoft-project-one pt-145 pb-105 pt-lg-55 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-25">
                                    <h3 className="sect-title mb-25" data-aos="fade-up">Trabajos Destacados</h3>
                                    <p data-aos="fade-up">Ofrecemos soluciones transparentes
                                        y entregas eficientes a través de fuentes internas u "orgánicas".</p>
                                </div>
                            </div>
                        </div>
                        {/* ProjectGridOne start */}
                        <ProjectGridOne />
                        {/* ProjectGridOne end */}
                        <div className="row">
                            <div className="col-lg-12 text-center mt-10 mb-45">
                                <Link className="theme_btn" to="/project-masonry">Cargar Más</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*cuysoft-project-one end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default ProjectGrid